// FullPageLoading.tsx
import React from "react";
import { IonPage, IonContent } from "@ionic/react";
import "./styles.css";

const FullPageLoading: React.FC = () => (
    <IonPage>
        <IonContent fullscreen>
            <div
                style={{
                    width: "100%",
                    minHeight: "100vh",
                    maxHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#000000",
                    overflow: "hidden"
                }}
            >
                <img
                    src="https://images-extras.s3.us-east-1.amazonaws.com/hamlet_gif.gif"
                    alt="Loading..."
                    width="100%"
                    height="auto"
                    style={{ objectFit: 'cover' }}
                    className="full-page-loader-desktop"
                />
                <img
                    src="https://images-extras.s3.us-east-1.amazonaws.com/hamlet_gif_mobile.gif"
                    alt="Loading..."
                    width="100%"
                    height="auto"
                    style={{ objectFit: 'cover' }}
                    className="full-page-loader-mobile"
                />
            </div>
        </IonContent>
    </IonPage>
);

export default FullPageLoading;
